import { render, staticRenderFns } from "./RoutesTable.vue?vue&type=template&id=10f0711e&scoped=true&"
import script from "./RoutesTable.vue?vue&type=script&lang=js&"
export * from "./RoutesTable.vue?vue&type=script&lang=js&"
import style0 from "./RoutesTable.vue?vue&type=style&index=0&id=10f0711e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0711e",
  null
  
)

export default component.exports